<template>
  <div
    class="md:flex-1 rounded-2xl bg-white-005 p-3 flex flex-col"
    style="height: 392px; table-layout: fixed"
  >
    <div class="flex justify-between items-center mb-4 ml-2">
      <div class="font-bold text-sm lg:text-xl">InFlow/OutFlow</div>
      <ShareBtn tip="InFlow/OutFlow" class="mr-2"></ShareBtn>
    </div>

    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex text-xs h-8 items-center mb-3" style="color: #ffffffb3">
        <div style="width: 45%" class="pl-4">Project</div>
        <div style="width: 20%">Type</div>
        <div class="text-right pr-8" style="width: 35%">DAO</div>
      </div>

      <div class="flex-1 min-h-0">
        <div class="w-full h-full overflow-y-scroll space-y-2" ref="container">
          <div v-for="(item, i) in results" :key="i">
            <router-link :to="`/dao/${item.daoPath}`">
              <div
                class="
                  flex
                  items-center
                  hover:bg-white-005
                  rounded
                  cursor-pointer
                  text-xs
                  py-2
                  h-12
                "
              >
                <div class="flex items-center pl-2" style="width: 45%">
                  <UiImg
                    class="
                      w-8
                      h-8
                      rounded-full
                      overflow-hidden
                      mr-2
                      flex-shrink-0
                    "
                    :src="item.tokenLogo"
                  ></UiImg>
                  <span class="font-bold line-clamp-2 pr-2">
                    {{ item.tokenName }}
                  </span>
                </div>
                <div class="font-bold" style="width: 20%">
                  <span
                    :style="`color:${
                      item.status == 'Buy' ? '#FF2640FF' : '#51D55BFF'
                    }`"
                    >{{ item.status == 'Buy' ? 'Bought' : 'Sold' }}</span
                  >

                  {{
                    item.type == 'NFT'
                      ? item.amount
                      : formatVal(item.amount, { bit: 2, omit: true })
                  }}
                </div>
                <div class="flex pr-2 justify-end" style="width: 35%">
                  <UiImg
                    class="w-8 h-8 rounded-full overflow-hidden mr-2"
                    :src="item.daoLogo"
                  ></UiImg>
                  <div>
                    <div
                      class="
                        font-bold
                        text-right
                        line-clamp-1
                        overflow-ellipsis
                      "
                    >
                      {{ item.daoName }}
                    </div>
                    <div style="color: #ffffffb3">
                      {{ formatDate(item.blockTimestamp, 'DD/MM HH:mm') }}
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div v-if="loading" class="space-y-2">
            <Skeletor
              class="w-full h-12 rounded"
              v-for="(_, i) in Array(5).fill(0)"
              :key="i"
            ></Skeletor>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { queryHomeTransferRecord } from '@/api/common';
import UiImg from '@/components/UiImg.vue';
import { useReqByBool, useReqPages } from '@/hooks';
import { inject, onMounted, reactive, ref, watch } from 'vue';
import { Skeletor } from 'vue-skeletor';
import { formatDate, formatVal } from '@/utils';
import { useInfiniteScroll } from '@vueuse/core';
import { withThrottling } from '@/utils/with';
import ShareBtn from './ShareBtn.vue';
import { homeChains, homeTypes } from './constant';

const curChain = inject('curChain');
const homeState = inject('homeState');

const state = reactive({
  list: [],
  isMounted: false,
});

const container = ref(null);

const { loadRest, loadNext, loading, results } = useReqPages(
  async (page, cancel) => {
    let res = await queryHomeTransferRecord(
      page,
      homeTypes[homeState.selectedType].value,
      homeChains[homeState.selectedChain].value,
      cancel,
    );
    res = res.data;

    const result = {
      lists: res.records,
      rows: res.size,
      total: res.total,
      pages: res.pages,
    };
    return result;
  },
);

useInfiniteScroll(
  container,
  withThrottling(async () => {
    await loadNext();
  }),
  { distance: 44 },
);

watch(
  () => [homeState.selectedType, homeState.selectedChain],
  () => {
    loadRest(true);
  },
);

onMounted(async () => {
  await loadRest();
  state.isMounted = true;
});
</script>

<style lang="scss" scoped></style>
